// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.failed-payments-table {
  width: 100%;
  border-collapse: collapse;
  background: var(--color-bg-dark);
  color: var(--color-text-white);
}
th, td {
  padding: var(--spacing-3) var(--spacing-4);
  border-bottom: 1px solid var(--color-primary);
}
th {
  background: var(--color-gray-800);
}
.status-failed {
  background: var(--color-primary);
  color: var(--color-bg-dark);
  padding: var(--spacing-1) var(--spacing-3);
  border-radius: var(--spacing-1);
}
.badge {
  padding: var(--spacing-1) var(--spacing-2);
  border-radius: var(--spacing-1);
  margin-left: var(--spacing-2);
  text-transform: capitalize;
  font-size: var(--font-size-sm);
}
.badge-success {
  background: var(--color-success);
  color: var(--color-text-white);
}
.badge-failed {
  background: var(--color-danger);
  color: var(--color-text-white);
}
.badge-unknown {
  background: var(--color-gray-500);
  color: var(--color-text-white);
}
.badge-norealizado {
  background: var(--color-gray-500);
  color: var(--color-text-white);
}
`, "",{"version":3,"sources":["webpack://./src/app/components/failed-payments-management/failed-payments-table.component.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,yBAAyB;EACzB,gCAAgC;EAChC,8BAA8B;AAChC;AACA;EACE,0CAA0C;EAC1C,6CAA6C;AAC/C;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,0CAA0C;EAC1C,+BAA+B;AACjC;AACA;EACE,0CAA0C;EAC1C,+BAA+B;EAC/B,6BAA6B;EAC7B,0BAA0B;EAC1B,8BAA8B;AAChC;AACA;EACE,gCAAgC;EAChC,8BAA8B;AAChC;AACA;EACE,+BAA+B;EAC/B,8BAA8B;AAChC;AACA;EACE,iCAAiC;EACjC,8BAA8B;AAChC;AACA;EACE,iCAAiC;EACjC,8BAA8B;AAChC","sourcesContent":[".failed-payments-table {\n  width: 100%;\n  border-collapse: collapse;\n  background: var(--color-bg-dark);\n  color: var(--color-text-white);\n}\nth, td {\n  padding: var(--spacing-3) var(--spacing-4);\n  border-bottom: 1px solid var(--color-primary);\n}\nth {\n  background: var(--color-gray-800);\n}\n.status-failed {\n  background: var(--color-primary);\n  color: var(--color-bg-dark);\n  padding: var(--spacing-1) var(--spacing-3);\n  border-radius: var(--spacing-1);\n}\n.badge {\n  padding: var(--spacing-1) var(--spacing-2);\n  border-radius: var(--spacing-1);\n  margin-left: var(--spacing-2);\n  text-transform: capitalize;\n  font-size: var(--font-size-sm);\n}\n.badge-success {\n  background: var(--color-success);\n  color: var(--color-text-white);\n}\n.badge-failed {\n  background: var(--color-danger);\n  color: var(--color-text-white);\n}\n.badge-unknown {\n  background: var(--color-gray-500);\n  color: var(--color-text-white);\n}\n.badge-norealizado {\n  background: var(--color-gray-500);\n  color: var(--color-text-white);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
